import React from "react";
import { ToastContainer } from "react-toastify";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import routes from "./Route";
import "./App.css";


import ThemeHandler from "./Components/ThemeHandler";

function App() {
  const queryClient = new QueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeHandler />
      <RouterProvider router={routes} />
      <ToastContainer />
    </QueryClientProvider>
  );
}

export default App;
